export default "__VITE_ASSET__589196c6__"